import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getUrlConfigs } from 'src/redux/core/coreSelectors';
import { E_URL_SCHEME } from 'src/shared/helpers/urlHelpers';
import { windowExist } from 'src/shared/constants';
import { useEffect, useState } from 'react';
export var useRouter = function () {
    var navigate = useNavigate();
    var urlConfigs = useSelector(getUrlConfigs);
    var withoutRealm = (urlConfigs === null || urlConfigs === void 0 ? void 0 : urlConfigs.urlScheme) === E_URL_SCHEME.GCP;
    var _a = useState(false), newTab = _a[0], setNewTab = _a[1];
    useEffect(function () {
        if (windowExist) {
            var handleKey_1 = function (e) {
                var ctrl = e.ctrlKey || e.metaKey;
                var shift = e.shiftKey;
                setNewTab(ctrl && !shift);
            };
            var handleTabChange_1 = function (e) { return ((document === null || document === void 0 ? void 0 : document.visibilityState) === 'visible' ? setNewTab(false) : null); };
            document.addEventListener('keydown', handleKey_1);
            document.addEventListener('keyup', handleKey_1);
            document.addEventListener('visibilitychange', handleTabChange_1);
            return function () {
                document.removeEventListener('keydown', handleKey_1);
                document.removeEventListener('keyup', handleKey_1);
                document.removeEventListener('visibilitychange', handleTabChange_1);
            };
        }
    });
    var urlEnhanced = function (url) {
        return "".concat(window.env.BASE_PATH || '').concat(withoutRealm || !(urlConfigs === null || urlConfigs === void 0 ? void 0 : urlConfigs.realm) ? url : "/".concat(urlConfigs === null || urlConfigs === void 0 ? void 0 : urlConfigs.realm).concat(url));
    };
    return {
        url: windowExist ? document.location.pathname : '',
        replace: function (url) {
            return windowExist && newTab ? window.open(urlEnhanced(url), '_blank') : navigate(urlEnhanced(url), { replace: true });
        },
        push: function (url) { return (windowExist && newTab ? window.open(urlEnhanced(url), '_blank') : navigate(urlEnhanced(url))); },
        goBack: function () { return navigate(-1); },
        refresh: windowExist ? function () { return window.location.reload(); } : null,
    };
};
